<template>
<div>
  <div class="media"  v-for="p in filteredProfiles" :key="p.profileName">
    <figure class="media-left">
      <p class="image is-48x48">
        <user-image class="is-circle m-b-16" v-if="p.profileName === 'website'" :user="currentJobseeker" size="is-48x48" />
        <img  class="m-b-16 is-circle" v-else width="48" :src="icon(p.profileName)" />
      </p>
    </figure>
    <div class="media-content is-flex is-flex-column m-t-4">
        <strong class="heading">{{label(p.profileName)}}</strong>
        <a :href="link(p)" target="_blank" class="m-t-8">{{p.profileValue | normalize}}</a>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { profileLabel, profileIcon, profileLink } from '@/helpers/external-profiles'
import UserImage from '@/components/general/user-image'

export default {
  components: { UserImage },
  computed: {
    ...mapGetters('users', ['profiles']),
    ...mapState('jobseekers', [
      'currentJobseeker'
    ]),
    filteredProfiles () {
      return this.profiles.filter((p) => {
        return p.profileValue !== null && p.profileValue !== ''
      })
    }
  },
  filters: {
    normalize (value) {
      if (!value) {
        return ''
      }
      return value.replace(/https?:\/\/(www\.)?/g, '')
    }
  },
  methods: {
    label (p) {
      return profileLabel(p)
    },
    icon (p) {
      return profileIcon(p)
    },
    link (p) {
      return profileLink(p)
    }
  }
}
</script>

<style scoped>
  .media-content {
    align-content: center;
  }
  .media-content a {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/profile/profiles/profile-list.vue